import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Input, Self } from '@angular/core';
import {
  CheckoutCustomerDetailsComponent,
  CheckoutProgressionStepsComponent,
} from '@checkout/feature-components';
import {
  BasketSummaryComponent,
  QuoteFreeMonthsPipe,
} from '@domgen/dgx-fe-basket';
import { CmsArea } from '@domgen/dgx-fe-cms';
import {
  ButtonGroupComponent,
  ButtonNavigateBackComponent,
  ButtonTextComponent,
} from '@domgen/dgx-fe-components/button';
import { CardComponent } from '@domgen/dgx-fe-components/card';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { GAPage } from '@domgen/dgx-fe-ga';
import {
  CurrencyFormatPipe,
  TranslatePipe,
  provideTranslationDictionaryMapping,
} from '@domgen/dgx-fe-i18n';
import { EditableArea } from '@magnolia/angular-editor';
import { DirectDebitFormComponent } from '../../components/direct-debit-form/direct-debit-form.component';
import { translation } from '../../i18n/translation.constant';
import { DirectDebitComponentService } from '../../services/direct-debit-component/direct-debit-component.service';
import { DirectDebitFormBuilder } from '../../services/direct-debit-form-builder/direct-debit-form-builder.service';

@Component({
  templateUrl: './direct-debit.component.html',
  styleUrls: ['./direct-debit.component.scss'],
  providers: [
    DirectDebitComponentService,
    DirectDebitFormBuilder,
    provideTranslationDictionaryMapping(translation),
  ],
  standalone: true,
  imports: [
    AsyncPipe,
    BasketSummaryComponent,
    ButtonGroupComponent,
    ButtonNavigateBackComponent,
    ButtonTextComponent,
    CardComponent,
    CheckoutCustomerDetailsComponent,
    CheckoutProgressionStepsComponent,
    CurrencyFormatPipe,
    DirectDebitFormComponent,
    EditableArea,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgIf,
    QuoteFreeMonthsPipe,
    TranslatePipe,
  ],
})
@GAPage()
export class DirectDebitComponent {
  @Input() main!: CmsArea;

  constructor(@Self() readonly cs: DirectDebitComponentService) {}
}
